/**
 * cs-promo-banner.js
 * Desktop: Prev / Next arrows (shown/hidden based on scroll position)
 * Mobile: pure CSS touch scroll — arrows hidden via CSS.
 */
(function () {
  'use strict';

  document.querySelectorAll('.cs-promo-track-wrap').forEach(function (wrap) {
    var scroll  = wrap.querySelector('[data-cs-promo-track]');
    var btnPrev = wrap.querySelector('.cs-promo-arrow--prev');
    var btnNext = wrap.querySelector('.cs-promo-arrow--next');

    if (!scroll) return;

    function updateArrows() {
      if (!btnPrev || !btnNext) return;

      var atStart = scroll.scrollLeft <= 4;
      var atEnd   = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 4;

      btnPrev.style.display = 'flex';
      btnNext.style.display = 'flex';

      btnPrev.classList.toggle('cs-promo-arrow--hidden', atStart);
      btnNext.classList.toggle('cs-promo-arrow--hidden', atEnd);
    }

    function scrollByCard(direction) {
      var card = scroll.querySelector('.cs-promo-card');
      var gap  = parseInt(getComputedStyle(scroll).gap, 10) || 12;
      var step = card ? card.offsetWidth + gap : 240;
      scroll.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (btnPrev) {
      btnPrev.removeAttribute('hidden');
      btnPrev.addEventListener('click', function () { scrollByCard(-1); });
    }
    if (btnNext) {
      btnNext.removeAttribute('hidden');
      btnNext.addEventListener('click', function () { scrollByCard(1); });
    }

    scroll.addEventListener('scroll', updateArrows, { passive: true });
    requestAnimationFrame(updateArrows);
  });

})();
